<template>
  <div class="bg-white">
    <loading :status="loading" />
    <template v-if="order.id">
      <div class="space-x-2 flex justify-between">
        <!--  <qr-code v-if="order.qr_link" :size="Number(app.printer.qr_code_size)" :color="app.printer.font_color" :text="`${order.qr_link}`"></qr-code> -->
        <h2 class="w-full font-bold tracking-wider uppercase">
          <span class="text-xl">{{ app.name }}</span>
          <small>
            <p v-if="app.phone">{{ app.phone }}</p>
            <p v-html="app.address"></p>
          </small>
        </h2>
      </div>
      <div class="border-b border-dotted border-black w-full p-1"></div>
      <div class="flex items-center mt-1">
        <label class="min-w-32 block font-bold uppercase">{{ $t('Sale Invoice date') }}</label>
        <span class="mr-4 inline-block">:</span>
        <div>{{ order.created_at }}</div>
      </div>
      <div class="flex items-center">
        <label class="min-w-32 block font-bold uppercase">{{ $t('Sale Invoice ID') }}</label>
        <span class="mr-4 inline-block">:</span>
        #{{ order.tracking }} [ {{ order.id }} ]
      </div>
      <div class="flex items-center">
        <label class="min-w-32 block font-bold uppercase">{{ $t('Tax Identity') }} ({{ $t('VAT') }})</label>
        <span class="mr-4 inline-block">:</span>
        #{{ order.tax.tax_id }}
      </div>
      <div class="flex items-center my-2">
        <table class="w-full">
          <thead class="bg-gray-100">
            <tr>
              <th class="font-semibold uppercase tracking-wider">{{ $t('No') }}</th>
              <th class="w-full font-semibold uppercase tracking-wider text-left pl-2 py-3">{{ $t('Item') }}</th>
              <th class="font-semibold uppercase tracking-wider">{{ $t('Qty') }}</th>
              <th class="font-semibold uppercase tracking-wider">{{ $t('Price') }}</th>
              <th class="font-semibold uppercase tracking-wider">{{ $t('SubTotal') }}</th>
            </tr>
          </thead>
          <tbody class="divide divide-gray-200">
            <tr class="text-center py-2" v-for="(item, index) in order.items" :key="index">
              <td>{{ index + 1 }}</td>
              <td class="text-left pl-2 py-2">
                {{ item.name }}
                <small v-if="item.title">({{ item.title }})</small>
                <small v-if="item.serial_number">({{ item.serial_number }})</small>
                <small v-if="item.identity">({{ item.identity }})</small>
              </td>
              <td>{{ item.qty }}</td>
              <td>{{ item.price | currency }}</td>
              <td>{{ item.sub_total | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="w-full bg-gray-100 mb-1 mt-1 py-2 overflow-hidden">
        <div class="px-1 flex justify-between font-semibold">
          <p>{{ $t('Items') }} :</p>
          <p class="pl-2">{{ order.cart_total_items }}</p>
        </div>
        <div class="px-1 flex justify-between font-semibold">
          <p>{{ $t('Subtotal') }} :</p>
          <p class="pl-2">{{ order.sub_total | currency }}</p>
        </div>
      </div>
      <div class="w-full bg-gray-100 mb-1 mt-1 py-2 overflow-hidden">
        <div class="px-1 flex justify-between font-semibold">
          <p>{{ $t('Discount') }}(-) :</p>
          <p class="pl-2">{{ order.discount | currency }}</p>
        </div>
        <div class="px-1 flex justify-between font-semibold">
          <template v-if="order.tax.is_tax_fix">
            <p>{{ $t('Tax') }} ({{ order.tax.rate }} {{ $t('fix') }}) :</p>
          </template>
          <template v-else>
            <p>{{ $t('Tax') }} ({{ order.tax.rate }}{{ order.tax.is_tax_fix ? '' : '%' }}) (+) :</p>
          </template>
          <p class="pl-2">{{ order.tax_amount | currency }}</p>
        </div>
        <div v-if="order.shipping" class="px-1 flex justify-between font-semibold">
          <p>{{ $t('Shipping') }} (+) :</p>
          <p class="pl-2">{{ order.shipping | currency }}</p>
        </div>
        <div class="px-1 flex justify-between font-semibold">
          <p>{{ $t('Total payable') }} ({{ order.is_cash_paid ? $t('Cash') : $t('Card') }}):</p>
          <p class="pl-2">{{ order.payable | currency }}</p>
        </div>
      </div>
      <div v-if="order.recepient_amount > 0 || order.change_amount > 0" class="bg-gray-100 py-2 mt-1 overflow-hidden">
        <div v-if="order.recepient_amount > 0" class="px-1 flex justify-between font-semibold">
          <p>{{ $t('Recipient amount') }} :</p>
          <p class="pl-2">{{ order.recepient_amount | currency }}</p>
        </div>
        <div v-if="order.change_amount > 0" class="px-1 flex justify-between font-semibold">
          <p>{{ $t('Change') }} :</p>
          <p class="pl-2">{{ order.change_amount | currency }}</p>
        </div>
      </div>
      <div class="border-b border-dotted border-black w-full"></div>
      <div class="pt-2">
        <template v-if="order.print_display_note">
          <div class="font-bold text-left">
            {{ $t('Note') }}
          </div>
          <div class="terms px-5">
            <p>{{ order.display_note }}</p>
          </div>
        </template>
        <template v-if="app.terms.sales">
          <div class="font-bold text-left">
            {{ $t('I acknowledge the following terms and conditions') }}
          </div>
          <div class="terms px-5">
            <p v-html="app.terms.sales"></p>
          </div>
        </template>
        <!--  <div class="flex justify-between">
          <div class="font-bold flex-1">
            {{ $t('Signature') }}
          </div>
          <div class="font-sm">------------------------------</div>
        </div> -->
      </div>
      <div class="flex place-content-center barder">
        <barcode width="1" :lineColor="app.printer.font_color" :value="order.tracking" class="self-center" height="25" />
      </div>
    </template>
  </div>
</template>
<script>
import VueBarcode from 'vue-barcode';
import VueQRCodeComponent from 'vue-qrcode-component';

export default {
  name: 'sale-order',
  metaInfo() {
    return {
      title: this.$i18n.t('Print sale order'),
    };
  },
  components: {
    'qr-code': VueQRCodeComponent,
    barcode: VueBarcode,
  },
  computed: {
    app() {
      return this.$store.getters['app/getSettings'];
    },
  },
  data() {
    return {
      loading: false,
      order: {
        qr_link: null,
        discount: 0,
        shipping: 0,
        tax: {
          rate: 0,
          tax_id: null,
          is_tax_included: false,
          is_tax_fix: false,
        },
      },
    };
  },
  mounted() {
    this.getSaleOrder();
  },
  methods: {
    getSaleOrder() {
      this.loading = true;
      axios
        .get(route('print-sale-order', this.$route.params.uuid))
        .then((response) => {
          this.order = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
